'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proxies = exports.general = exports.exchangesV1 = exports.dappHub = exports.daiV1 = undefined;

var _ERC = require('./abis/ERC20.json');

var _ERC2 = _interopRequireDefault(_ERC);

var _WETH = require('./abis/WETH9.json');

var _WETH2 = _interopRequireDefault(_WETH);

var _DSValue = require('./abis/DSValue.json');

var _DSValue2 = _interopRequireDefault(_DSValue);

var _DSGuard = require('./abis/DSGuard.json');

var _DSGuard2 = _interopRequireDefault(_DSGuard);

var _DSChief = require('./abis/DSChief.json');

var _DSChief2 = _interopRequireDefault(_DSChief);

var _DSSpell = require('./abis/DSSpell.json');

var _DSSpell2 = _interopRequireDefault(_DSSpell);

var _DSSpellBook = require('./abis/DSSpellBook.json');

var _DSSpellBook2 = _interopRequireDefault(_DSSpellBook);

var _DSProxy = require('./abis/DSProxy.json');

var _DSProxy2 = _interopRequireDefault(_DSProxy);

var _DSProxyFactory = require('./abis/DSProxyFactory.json');

var _DSProxyFactory2 = _interopRequireDefault(_DSProxyFactory);

var _MatchingMarket = require('./abis/MatchingMarket.json');

var _MatchingMarket2 = _interopRequireDefault(_MatchingMarket);

var _ProxyCreationAndExecute = require('./abis/ProxyCreationAndExecute.json');

var _ProxyCreationAndExecute2 = _interopRequireDefault(_ProxyCreationAndExecute);

var _SaiProxyCreateAndExecute = require('./abis/SaiProxyCreateAndExecute.json');

var _SaiProxyCreateAndExecute2 = _interopRequireDefault(_SaiProxyCreateAndExecute);

var _ProxyRegistry = require('./abis/ProxyRegistry.json');

var _ProxyRegistry2 = _interopRequireDefault(_ProxyRegistry);

var _SaiTop = require('./abis/SaiTop.json');

var _SaiTop2 = _interopRequireDefault(_SaiTop);

var _SaiTub = require('./abis/SaiTub.json');

var _SaiTub2 = _interopRequireDefault(_SaiTub);

var _SaiTap = require('./abis/SaiTap.json');

var _SaiTap2 = _interopRequireDefault(_SaiTap);

var _SaiVox = require('./abis/SaiVox.json');

var _SaiVox2 = _interopRequireDefault(_SaiVox);

var _SaiMom = require('./abis/SaiMom.json');

var _SaiMom2 = _interopRequireDefault(_SaiMom);

var _GemPit = require('./abis/GemPit.json');

var _GemPit2 = _interopRequireDefault(_GemPit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daiV1 = {
  saiTop: _SaiTop2.default,
  tub: _SaiTub2.default,
  tap: _SaiTap2.default,
  vox: _SaiVox2.default,
  mom: _SaiMom2.default,
  pit: _GemPit2.default
};

var dappHub = {
  dsValue: _DSValue2.default,
  dsEthToken: _WETH2.default,
  dsGuard: _DSGuard2.default,
  dsChief: _DSChief2.default,
  dsSpell: _DSSpell2.default,
  dsSpellBook: _DSSpellBook2.default,
  dsProxy: _DSProxy2.default
};

var exchangesV1 = {
  makerOtc: _MatchingMarket2.default
};

var general = {
  erc20: _ERC2.default
};

var proxies = {
  oasisProxy: _ProxyCreationAndExecute2.default,
  saiProxy: _SaiProxyCreateAndExecute2.default,
  dsProxyFactory: _DSProxyFactory2.default,
  proxyRegistry: _ProxyRegistry2.default
};

exports.daiV1 = daiV1;
exports.dappHub = dappHub;
exports.exchangesV1 = exchangesV1;
exports.general = general;
exports.proxies = proxies;